import { HttpClient } from "@angular/common/http";
import { LacrosseEntity } from "../lacrosse.entity";
import { FirebaseAuthService } from "../../noizu/services/firebase-auth.service";

export class UserLocationEntity extends LacrosseEntity {
  public linkedDevices = [];
  public name = "Default";
  public ownerId = "";
  public saving = false;
  public showExtra = false;
  public position = 0;
  public weight = 0;
  public newPos = null;
  constructor(client: HttpClient, auth: FirebaseAuthService, json) {
    super(client, auth, json);
    this.name = json.name ? json.name : "Default";
    this.ownerId = json.ownerId;
    this.weight = json.weight != null ? json.weight : 0;
  }

  deleteLocation() {
    let locationID = this.raw.id;
    let ownerID = this.raw.ownerId;
    let url = `${this.apiBase()}/user/${ownerID}/location/${locationID}`;

    return this._delete(
      url,
      (_data, resolve) => {
        resolve(true);
      },
      {}
    );
  }

  createLocation() {
    if (this.identifier == "new" && this.linkedDevices.length == 0) {
      let ownerId = this.ownerId;
      console.log(ownerId);
      let name = this.name ? this.name : "defaultName";
      let data = {
        ownerId: ownerId,
        name: name,
      };
      let url = `${this.apiBase()}/user/${ownerId}/locations`;

      return this._post(
        url,
        data,
        (_data, resolve) => {
          resolve(true);
        },
        {}
      );
    } else {
      alert("Location not valid for creation");
      return null;
    }
  }

  /** Move this location to appear BEFORE the given target location identifier */
  rankBefore(targetId: string) {
    const url = `${this.apiBase()}/user/${this.ownerId}/location/${this.identifier}/rank/before/${targetId}`;
    return this._post(url, {}, (_data, resolve) => { resolve(true); }, {});
  }

  /** Move this location to appear AFTER the given target location identifier */
  rankAfter(targetId: string) {
    const url = `${this.apiBase()}/user/${this.ownerId}/location/${this.identifier}/rank/after/${targetId}`;
    return this._post(url, {}, (_data, resolve) => { resolve(true); }, {});
  }

  /**
   * Smart reposition: compares weights to decide before vs after.
   * If this location's weight > targetWeight  → moving to a lower weight position → rankBefore
   * If this location's weight < targetWeight  → moving to a higher weight position → rankAfter
   * Falls back to rankBefore if equal (no-op scenario).
   */
  reposition(targetId: string, targetWeight?: number) {
    if (targetWeight != null) {
      if (this.weight > targetWeight) {
        return this.rankBefore(targetId);
      } else {
        return this.rankAfter(targetId);
      }
    }
    // Legacy fallback – always rank before (original behaviour)
    return this.rankBefore(targetId);
  }
}
